<div class="settings-page">
  <div class="settings-header">
    <h1>Settings</h1>
    <p>Manage your preferences</p>
  </div>

  <div class="settings-card">
    <div class="card-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="2" y1="12" x2="22" y2="12"></line>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
      </svg>
    </div>
    <div class="card-content">
      <div class="card-info">
        <h3>Language / ဘာသာစကား</h3>
      </div>
      <div class="lang-toggle">
        <button
          class="lang-btn"
          [class.active]="currentLang() === 'en'"
          (click)="setLanguage('en')"
        >
          English
        </button>
        <button
          class="lang-btn"
          [class.active]="currentLang() === 'mm'"
          (click)="setLanguage('mm')"
        >
          မြန်မာ
        </button>
      </div>
    </div>
  </div>
</div>
